import importerSelectors from '../../../modules/shared/importer/importerSelectors'

const mediaImporterSelectors = importerSelectors(
  'media.importer',
)

export default mediaImporterSelectors
